import { useAppSelector } from '../../redux/hooks';
import { selectLanguages } from '../../redux/selectors';

import styles from './styles.module.scss';

const SpraakValg: React.FC = () => {
  const cmsData = useAppSelector(selectLanguages) || [];

  if (cmsData.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <p className={styles.text}>{'Språk'}</p>
      {cmsData.map(spraak => (
        <a
          key={spraak.cultureName}
          href={spraak.resolvedUrl}
          className={spraak.isCurrentLanguage ? styles.buttonFilled : styles.buttonOutlined}
        >
          {spraak.language}
        </a>
      ))}
    </div>
  );
};

export default SpraakValg;
